import { CurrencySetting, Point } from "../../type";

export type MatchedLine = {
  points: { x: number; y: number }[];
  win: number;
  beforeWin: number;
};

export type HunkCaiShenGameData = {
  category: number;
  animationGroup?: { [k: number]: MatchedLine };
  multiplys: multiply[];
  scatterMultiplier: number;
  scatterPoints: Point[];
};

export type multiply = {
  x: number;
  y: number;
  value: number;
};

export enum FESymbols {
  Wild = 600,
  Scatter = 25,
  Symbol1 = 201,
  Symbol2 = 202,
  Symbol3 = 203,
  Symbol4 = 204,
  Symbol5 = 205,
  Symbol6 = 206,
  LowSymbol1 = 101,
  LowSymbol2 = 102,
  LowSymbol3 = 103,
  LowSymbol4 = 104,
}

export enum Symbols {
  Wild3 = 8201,
  Wild4 = 8202,
  Wild5 = 8203,
  Scatter = 25,
  Symbol1 = 201,
  Symbol2 = 202,
  Symbol3 = 203,
  Symbol4 = 204,
  Symbol5 = 205,
  Symbol6 = 206,
  LowSymbol1 = 101,
  LowSymbol2 = 102,
  LowSymbol3 = 103,
  LowSymbol4 = 104,
}

export type Rule = {
  payouts: { [k: number]: { [k: number]: number } };
};

export type Setting = {
  currencies: CurrencySetting[];
  payouts: { [k: string]: Payout };
  buyFreeSpinRate: number;
};

export type Payout = { [k: string]: number };

export type SpinHistory = {
  id: string;
  level: number;
  reelMatrix: number[][];
  addedFreeSpin: number;
  gameData?: HunkCaiShenGameData;
  state: string;
  winAmount: string;
  mode: string;
  spinDate: string;
  playRefNumber: string;
  focus: boolean;
};
